import React, { useEffect, useState } from 'react';

import Chart from "react-apexcharts";

function CategoryHeatmapCard({
  data,
  name
}) {

  const [ options, setOptions ] = useState(null)
  const [ series, setSeries ] = useState(null)

  useEffect(() => {
    if(data!=null && name!=null) {
      setSeries([{
        name: name,
        data: data
      }])
      setOptions({
        chart: {
          height: 150,
          type: "heatmap",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#f9c418"]
      })
    }
  }, [data, name]);

  return (
      <div className="flex-grow">
        {data!= null && options != null && series != null && series.length>0 ? <Chart
          options={options}
          type="heatmap"
          width="100%"
          height={100}
          series={series}/> : 'No delivery information found.'}
      </div>
  );
}

export default CategoryHeatmapCard;
